const rootSchema = {
  "@context": "https://schema.org",
  "@graph": [
    // ORGANIZATION: you as the “owner” of the site
    {
      "@type": "Organization",
      "@id": "https://yutnori.app/#organization",
      "name": "yutnori.app",
      "url": "https://yutnori.app/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://yutnori.app/logo.png"
      },
      "description":
        "yutnori.app is an online version of the Korean board game Yutnori (윷놀이), with a 3D animated rulebook and real-time multiplayer play in the browser.",
      // my social links
      "sameAs": [
        "https://twitter.com/your-handle",
        "https://github.com/moonsujo"
      ]
    },

    // WEBSITE: the site itself
    {
      "@type": "WebSite",
      "@id": "https://yutnori.app/#website",
      "url": "https://yutnori.app/",
      "name": "yutnori.app – Play Yutnori (윷놀이) Online",
      "description":
        "Play Yutnori (윷놀이), the traditional Korean board game, directly in your browser. Host or join online games, learn the rules through a 3D animated rulebook, and play with friends.",
      "inLanguage": ["ko", "en"],
      "publisher": {
        "@id": "https://yutnori.app/#organization"
      }
      // If you add a real search feature later, you can add:
      // "potentialAction": {
      //   "@type": "SearchAction",
      //   "target": "https://yutnori.app/?q={search_term_string}",
      //   "query-input": "required name=search_term_string"
      // }
    },

    // GAME / APP: the online game itself
    {
      "@type": "VideoGame",
      "@id": "https://yutnori.app/#game",
      "name": "Yutnori Online (윷놀이)",
      "alternateName": ["Yut", "Yunnori", "Yoot", "Korean Board Game"],
      "url": "https://yutnori.app/",
      "image": "https://yutnori.app/og-image.png",
      "description":
        "A 3D online multiplayer version of Yutnori (윷놀이), the traditional Korean board game. Play in your browser with friends, watch animated stick throws, and learn the rules through an interactive rulebook.",
      "genre": ["Board game", "Strategy", "Korean Traditional Game", "Multiplayer"],
      "playMode": ["MultiPlayer", "SinglePlayer"],
      "numberOfPlayers": {
        "@type": "QuantitativeValue",
        "minValue": "1",
        "maxValue": "8"
      },
      "gamePlatform": ["Web Browser", "Desktop", "Mobile", "Tablet"],
      "inLanguage": ["ko", "en"],
      "applicationCategory": "Game",
      "operatingSystem": "Web browser",
      "browserRequirements": "Requires a modern web browser with WebGL support.",
      "publisher": {
        "@id": "https://yutnori.app/#organization"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.7",
        "ratingCount": "150",
        "bestRating": "5",
        "worstRating": "1"
      },
      "keywords": "yutnori, 윷놀이, korean board game, traditional korean game, yut sticks, multiplayer board game, 3D board game, free online game, cultural game, strategy game"
    }
  ]
};

export default rootSchema;
